import Home from './Home.svelte'
import Intro1 from './Intro1.svelte'
import Intro2 from './Intro2.svelte'
import Intro3 from './Intro3.svelte'
import Test1 from './Test1.svelte'
import Test2 from './Test2.svelte'
import Test3 from './Test3.svelte'
import Test4 from './Test4.svelte'
import Test5 from './Test5.svelte'
import Result from './Result.svelte'
import DogName from './DogName.svelte'
import Example from './Example.svelte'

const routes = [
  { name: '/', component: Home },
  { name: '/intro1', component: Intro1 },
  { name: '/intro2', component: Intro2 },
  { name: '/intro3', component: Intro3 },
  { name: '/test1', component: Test1 },
  { name: '/test2', component: Test2 },
  { name: '/test3', component: Test3 },
  { name: '/test4', component: Test4 },
  { name: '/test5', component: Test5 },
  { name: '/result', component: Result },
  { name: '/dog_name', component: DogName },
  { name: '/example', component: Example },
]

export { routes }

